const MERGE_FIELD_CATEGORIES = [
  {
    name: 'components.lexical.merge_fields.Name Fields',
    options: [
      {
        key: 'employee_name',
        name: 'components.lexical.merge_fields.Employee Preferred Name',
        placeholder: 'components.lexical.merge_fields.#[Employee Preferred Name]',
      },
      {
        key: 'employee_legal_name',
        name: 'components.lexical.merge_fields.Employee Name',
        placeholder: 'components.lexical.merge_fields.#[Employee Name]',
      },
      {
        key: 'first_name',
        name: 'components.lexical.merge_fields.First Name',
        placeholder: 'components.lexical.merge_fields.#[First Name]',
      },
      {
        key: 'middle_name',
        name: 'components.lexical.merge_fields.Middle Name',
        placeholder: 'components.lexical.merge_fields.#[Middle Name]',
      },
      {
        key: 'last_name',
        name: 'components.lexical.merge_fields.Last Name',
        placeholder: 'components.lexical.merge_fields.#[Last Name]',
      },
      {
        key: 'preferred_name',
        name: 'components.lexical.merge_fields.Preferred Name',
        placeholder: 'components.lexical.merge_fields.#[Preferred Name]',
      },
      {
        key: 'preferred_last_name',
        name: 'components.lexical.merge_fields.Preferred Last Name',
        placeholder: 'components.lexical.merge_fields.#[Preferred Last Name]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Personal Information',
    options: [
      {
        key: 'birth_date',
        name: 'components.lexical.merge_fields.Birth Date',
        placeholder: 'components.lexical.merge_fields.#[Birth Date]',
      },
      {
        key: 'age',
        name: 'components.lexical.merge_fields.Age',
        placeholder: 'components.lexical.merge_fields.#[Age]',
      },
      {
        key: 'gender',
        name: 'components.lexical.merge_fields.Gender',
        placeholder: 'components.lexical.merge_fields.#[Gender]',
      },
      {
        key: 'custom_gender',
        name: 'components.lexical.merge_fields.Custom Gender',
        placeholder: 'components.lexical.merge_fields.#[Custom Gender]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Contact Information',
    options: [
      {
        key: 'work_email',
        name: 'components.lexical.merge_fields.Work Email',
        placeholder: 'components.lexical.merge_fields.#[Work Email]',
      },
      {
        key: 'personal_email',
        name: 'components.lexical.merge_fields.Personal Email',
        placeholder: 'components.lexical.merge_fields.#[Personal Email]',
      },
      {
        key: 'work_phone',
        name: 'components.lexical.merge_fields.Work Phone',
        placeholder: 'components.lexical.merge_fields.#[Work Phone]',
      },
      {
        key: 'work_phone_extension',
        name: 'components.lexical.merge_fields.Work Phone Extension',
        placeholder: 'components.lexical.merge_fields.#[Work Phone Extension]',
      },
      {
        key: 'personal_phone',
        name: 'components.lexical.merge_fields.Personal Phone',
        placeholder: 'components.lexical.merge_fields.#[Personal Phone]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Address Information',
    options: [
      {
        key: 'home_address_1',
        name: 'components.lexical.merge_fields.Home Address 1',
        placeholder: 'components.lexical.merge_fields.#[Home Address 1]',
      },
      {
        key: 'home_address_2',
        name: 'components.lexical.merge_fields.Home Address 2',
        placeholder: 'components.lexical.merge_fields.#[Home Address 2]',
      },
      {
        key: 'city',
        name: 'components.lexical.merge_fields.City',
        placeholder: 'components.lexical.merge_fields.#[City]',
      },
      {
        key: 'region',
        name: 'components.lexical.merge_fields.Region',
        placeholder: 'components.lexical.merge_fields.#[Region]',
      },
      {
        key: 'region_code',
        name: 'components.lexical.merge_fields.Region Code',
        placeholder: 'components.lexical.merge_fields.#[Region Code]',
      },
      {
        key: 'postal_code',
        name: 'components.lexical.merge_fields.Postal Code',
        placeholder: 'components.lexical.merge_fields.#[Postal Code]',
      },
      {
        key: 'country',
        name: 'components.lexical.merge_fields.Country',
        placeholder: 'components.lexical.merge_fields.#[Country]',
      },
      {
        key: 'country_code',
        name: 'components.lexical.merge_fields.Country Code',
        placeholder: 'components.lexical.merge_fields.#[Country Code]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Employment Information',
    options: [
      {
        key: 'employment_status',
        name: 'components.lexical.merge_fields.Employment Status',
        placeholder: 'components.lexical.merge_fields.#[Employment Status]',
      },
      {
        key: 'employment_type',
        name: 'components.lexical.merge_fields.Employment Type',
        placeholder: 'components.lexical.merge_fields.#[Employment Type]',
      },
      {
        key: 'start_date',
        name: 'components.lexical.merge_fields.Start Date',
        placeholder: 'components.lexical.merge_fields.#[Start Date]',
      },
      {
        key: 'job_title',
        name: 'components.lexical.merge_fields.Job Title',
        placeholder: 'components.lexical.merge_fields.#[Job Title]',
      },
      {
        key: 'hours_per_week',
        name: 'components.lexical.merge_fields.Hours Per Week',
        placeholder: 'components.lexical.merge_fields.#[Hours Per Week]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Organizational Information',
    options: [
      {
        key: 'department_name',
        name: 'components.lexical.merge_fields.Department Name',
        placeholder: 'components.lexical.merge_fields.#[Department Name]',
      },
      {
        key: 'location_name',
        name: 'components.lexical.merge_fields.Location Name',
        placeholder: 'components.lexical.merge_fields.#[Location Name]',
      },
      {
        key: 'reports_to',
        name: 'components.lexical.merge_fields.Reports to',
        placeholder: 'components.lexical.merge_fields.#[Reports to]',
      }
    ]
  },
  {
    name: 'components.lexical.merge_fields.Compensation',
    options: [
      {
        key: 'salary',
        name: 'components.lexical.merge_fields.Salary (or pay rate)',
        placeholder: 'components.lexical.merge_fields.#[Salary]',
      },
      {
        key: 'pay_rate_currency',
        name: 'components.lexical.merge_fields.Pay Rate Currency',
        placeholder: 'components.lexical.merge_fields.#[Pay Rate Currency]',
      },
      {
        key: 'pay_rate_unit',
        name: 'components.lexical.merge_fields.Pay Rate Unit',
        placeholder: 'components.lexical.merge_fields.#[Pay Rate Unit]',
      },
      {
        key: 'pay_frequency',
        name: 'components.lexical.merge_fields.Pay Frequency',
        placeholder: 'components.lexical.merge_fields.#[Pay Frequency]',
      },
      {
        key: 'annualized_commission',
        name: 'components.lexical.merge_fields.Annualized Commission',
        placeholder: 'components.lexical.merge_fields.#[Annualized Commission]',
      },
      {
        key: 'bonus_structure',
        name: 'components.lexical.merge_fields.Bonus Structure',
        placeholder: 'components.lexical.merge_fields.#[Bonus Structure]',
      },
      {
        key: 'commission_structure',
        name: 'components.lexical.merge_fields.Commission Structure',
        placeholder: 'components.lexical.merge_fields.#[Commission Structure]',
      }
    ]
  }
];

export default MERGE_FIELD_CATEGORIES;
